var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vue-datepicker-local", {
    attrs: {
      value: _vm.value,
      "input-class": "form-control form-control-sm " + _vm.inputclass,
      format: _vm.$t("format.date"),
      local: _vm.local,
      disabled: _vm.disabled,
      clearable: _vm.clearable,
    },
    on: { input: _vm.inputChanged },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }